// extracted by mini-css-extract-plugin
export var deleteIcon = "_lf-5";
export var deleteOption = "_lf-3";
export var divider = "_lf-2";
export var downloadIcon = "_lf-4";
export var drawer = "_lf-0";
export var drawerFooter = "_lf-6";
export var drawerOpen = "_lf-1";
export var highlighted = "_lf-7";
export var lighterHighlight = "_lf-8";